import type { AnnualReturnRow } from 'stores/annual-returns-store';
import type { ArType, UnitReturnSummary } from 'src/types/annualReturn';
import { ANNUAL_RETURN_TYPE } from 'src/constants/annualReturnType';
import { AR_STATUS, type ArStatus } from 'src/constants/annualReturnStatus';

/**
 * Translate an AnnualReturnRow's `type` ('organisation' | 'region') into the
 * unit-facing `ArType` ('organisation' | 'regional').
 */
export function toArType(row: AnnualReturnRow): ArType {
  return row.type === ANNUAL_RETURN_TYPE.REGION ? 'regional' : 'organisation';
}

/**
 * Map an AnnualReturnRow into the narrow `UnitReturnSummary` card view-model used
 * by the unit-facing dashboard. The `payee` (short name + plain-language payee)
 * is resolved by the caller via `useAnnualReturnPayee`, keeping this a pure
 * mapping with no store dependency.
 */
export function toUnitReturnSummary(
  row: AnnualReturnRow,
  payee: { shortName: string; payee: string }
): UnitReturnSummary {
  return {
    id: row.id,
    ar_type: toArType(row),
    short_name: payee.shortName,
    organisation_id: row.organisation_id ?? null,
    payee: payee.payee,
    ar_year: row.ar_year ?? 0,
    status: (row.status as ArStatus) ?? AR_STATUS.PREVIEW,
    members_total: row.members_total ?? 0,
    total_owed: Number(row.total_owed ?? 0),
    outstanding_balance: Number(row.outstanding_balance ?? 0),
    due_at: row.due_at ?? '',
    locked_at: row.locked_at ?? null,
    opens_at: row.active_from ?? null,
    ends_at: row.active_to ?? null,
    secretary_accepted_at: row.secretary_accepted_at ?? null,
    treasurer_accepted_at: row.treasurer_accepted_at ?? null,
  };
}
